import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../utils/axios";

const initialState = {
    enquiryTypes: [
        {
            id: 1,
            label: 'For User Queries',
            value: 'user_query'
        },
        {
            id: 2,
            label: 'For Business Queries',
            value: 'business_query'
        },
        {
            id: 3,
            label: 'For Purchase/Order Queries',
            value: 'purchase_order_query'
        },
        {
            id: 4,
            label: 'For Reporting Issues',
            value: 'report_issue'
        },
        {
            id: 5,
            label: 'General Query/Feedback',
            value: 'general_feedback'
        }
    ],
}

export const contactUsSlice = createSlice({
    name: "contactUs",
    initialState,
    reducers: {},
});

export const { } = contactUsSlice.actions;

export default contactUsSlice.reducer;


/**
 * @async
 * @function sendContactUsForm
 * @description Thunk to send contact us request form data to the backend
 * @param {Object} payload - The contact us form data
 * @returns {Object} - The response from the backend
 * 
 * @example
 * dispatch(sendContactUsForm({
 *   enquiry_type: 'business_query',
 *   name: 'John Doe',
 *   contact_email: 'john.doe@example.com',
 * }))
 */
export const sendContactUsForm = createAsyncThunk(
    'contactUs/sendContactUsForm',
    async (payload, { rejectWithValue }) => {
        try {
            const backendResponse = await axios.post('/api/v2/contact-us', payload);

            const response = {
                ...backendResponse?.data,
                code: backendResponse?.status
            }

            return response;
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
)


/**
 * @async
 * @function findTickets
 * @description Thunk to find the tickets by some parameters
 * @param {Object} payload - The ticket search data
 * @returns {Object} - The response from the backend
 * 
 * @example
 * dispatch(findTickets({
 *   "name": "",
 *   "email": "",
 *   "phone":"",
 *   "event_name":"",
 *   "booking_number": ""
 * }))
 */
export const findTickets = createAsyncThunk(
    'contactUs/findTickets',
    async (payload, { rejectWithValue }) => {
        try {
            const backendResponse = await axios.post('/api/v2/find-tickets', payload);

            const response = {
                ...backendResponse?.data,
                code: backendResponse?.status
            }

            return response;
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
)